module.exports = __webpack_public_path__ + "static/media/doi.5b46cdd6.png";